import axios from "axios"

interface ListResponse<T> {
  items: T[]
  offset: number
  count: number
}

interface RequestParams {
  [key: string]: string
}

class Api {
  static createFromEnv(): Api {
    return new Api(
      process.env.VUE_APP_API_URL || "https://api.hub.flixcheck.com/api/0/",
    )
  }

  constructor(public baseUrl: string) {}

  async getList<T>(
    path: string,
    params: RequestParams = {},
  ): Promise<ListResponse<T>> {
    const response = await axios.get(this.createUrl(path), {
      params,
      headers: this.createHeaders(),
    })
    return response.data
  }

  async get<T>(
    path: string,
    id: string,
    params: RequestParams = {},
  ): Promise<T> {
    const response = await axios.get(this.createUrl(path, id), {
      params,
      headers: this.createHeaders(),
    })
    return response.data
  }

  async post<T>(
    path: string,
    payload: any,
    params: RequestParams = {},
  ): Promise<T> {
    const response = await axios.post(this.createUrl(path), payload, {
      params,
      headers: this.createHeaders(),
    })
    return response.data
  }

  async patch<T>(
    path: string,
    id: string,
    payload: any,
    params: RequestParams = {},
  ): Promise<T> {
    const response = await axios.patch(this.createUrl(path, id), payload, {
      params,
      headers: this.createHeaders(),
    })
    return response.data
  }

  async delete(
    path: string,
    id: string,
    params: RequestParams = {},
  ): Promise<void> {
    await axios.delete(this.createUrl(path, id), {
      params,
      headers: this.createHeaders(),
    })
  }

  private createUrl(...parts: string[]): string {
    return `${this.baseUrl}${parts.join("/")}`
  }

  private createHeaders() {
    const headers: { [key: string]: string } = {}

    return headers
  }
}

export { Api, ListResponse }
